import { useState } from "react";
import { Link } from "react-router-dom";
import { Loader2, MailCheck } from "lucide-react";
import { capi, apiError } from "@/lib/api";
import { AuthCard, FieldLabel, Notice, inputCls, btnCls } from "@/components/account/AuthCard";

export default function AccountRegister() {
  const [f, setF] = useState({ name: "", email: "", password: "", confirm: "" });
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState("");
  const [sent, setSent] = useState(false);
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    setErr("");
    if (f.password.length < 8) { setErr("Password must be at least 8 characters."); return; }
    if (f.password !== f.confirm) { setErr("Passwords don't match."); return; }
    setBusy(true);
    try {
      await capi.post("/account/register", { name: f.name, email: f.email, password: f.password, origin: window.location.origin });
      setSent(true);
    } catch (e2) { setErr(apiError(e2)); }
    finally { setBusy(false); }
  };

  if (sent) return (
    <AuthCard title="Check your email" testid="register-success">
      <MailCheck className="h-10 w-10 text-kys-accent" />
      <p className="mt-4 text-sm text-kys-charcoal">
        We sent a verification link to <strong>{f.email}</strong>. Click it to activate your account, then sign in.
      </p>
      <p className="mt-3 text-xs text-kys-muted">Any custom requests you've already sent with this email will appear in your account once it's verified.</p>
      <Link to="/account/login" className="mt-6 inline-flex text-sm font-semibold text-kys-accent hover:underline">Go to sign in →</Link>
    </AuthCard>
  );

  return (
    <AuthCard title="Create account" subtitle="Use the same email as your custom requests to see them all in one place." testid="account-register-page">
      <form onSubmit={submit} className="space-y-4">
        {err && <Notice testid="register-error">{err}</Notice>}
        <div><FieldLabel>Name</FieldLabel><input data-testid="register-name" required value={f.name} onChange={set("name")} className={inputCls} /></div>
        <div><FieldLabel>Email</FieldLabel><input data-testid="register-email" type="email" required value={f.email} onChange={set("email")} className={inputCls} /></div>
        <div><FieldLabel>Password (8+ characters)</FieldLabel><input data-testid="register-password" type="password" required value={f.password} onChange={set("password")} className={inputCls} /></div>
        <div><FieldLabel>Confirm password</FieldLabel><input data-testid="register-confirm" type="password" required value={f.confirm} onChange={set("confirm")} className={inputCls} /></div>
        <button data-testid="register-submit" disabled={busy} className={btnCls}>
          {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : "Create account"}
        </button>
      </form>
      <p className="mt-6 text-center text-sm text-kys-muted">
        Already have an account? <Link to="/account/login" data-testid="go-login-link" className="font-semibold text-kys-accent hover:underline">Sign in</Link>
      </p>
    </AuthCard>
  );
}
